import { useState } from 'react';
import type { AnySourceConfig, FilterValue, FilterValues } from '../types';
import { isEmpty } from '../utils';

export function useReportFilters(source: AnySourceConfig) {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [draft, setDraft] = useState<FilterValues>({});
  const [applied, setApplied] = useState<FilterValues>({});

  const appliedCount = Object.values(applied).filter((v) => !isEmpty(v)).length;

  const openFilters = () => { setDraft(applied); setFiltersOpen(true); };
  const closeFilters = () => setFiltersOpen(false);

  const setDraftValue = (key: string, value: FilterValue) =>
    setDraft((prev) => {
      const next = { ...prev, [key]: value };
      source.filters.forEach((f) => { if (f.dependsOn?.key === key) next[f.key] = null; });
      return next;
    });

  const applyFilters = () => { setApplied(draft); setFiltersOpen(false); };
  const clearFilters = () => { setDraft({}); setApplied({}); setFiltersOpen(false); };

  return {
    filtersOpen, draft, applied, appliedCount,
    openFilters, closeFilters, setDraftValue, applyFilters, clearFilters,
  };
}